<template>
    <div class="credit-debit-tab">
        <BasePanel>
            <template #content>
                <template v-if="!successful">
                    <div class="amount-to">
                        <h3 class="title title__medium">{{ tokens.newDesign.amountToWithdrawal }}</h3>
                        <div class="inputs-list">
                            <BaseInput v-model="amount" :type="'number'" :title="tokens.newDesign.amount" :placeholder="'0.00'">
                                <template #icon>
                                    <p class="body__large">{{currencySign(activeAccount.currency)}}</p>
                                </template>
                                <template #info>
                                    <p class="body__large">{{ activeAccount.currency }}</p>
                                </template>
                            </BaseInput>
                        </div>
                    </div>
                    <div class="card-details">
                        <h3 class="title title__medium">{{ tokens.newDesign.cardDetails }}</h3>
                        <div class="inputs-list">
                            <BaseInput 
                                v-model="cardNumber" 
                                :mask="'####' + ' ####'.repeat(15)"
                                :title="tokens.newDesign.cardNumber"
                                :placeholder="'0000 0000 0000 0000'"
                                :id="'info-slot-hidden-mobile'"
                            >
                                <template #info>
                                    <div class="cards-list">
                                        <template v-if="['finquickly','tradreview','stockmtks','tradersclub', 'attrading','freedness'].includes(brand)">
                                            <svg width="24" height="16" viewBox="0 0 24 16" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_3101_94302)">
                                                    <mask id="mask0_3101_94302" style="mask-type:luminance"
                                                        maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="16">
                                                        <path d="M24 0H0V16H24V0Z" fill="white" />
                                                    </mask>
                                                    <g mask="url(#mask0_3101_94302)">
                                                        <path
                                                            d="M21.9574 0H2.04255C0.914482 0 0 0.924315 0 2.06452V13.9355C0 15.0757 0.914482 16 2.04255 16H21.9574C23.0855 16 24 15.0757 24 13.9355V2.06452C24 0.924315 23.0855 0 21.9574 0Z"
                                                            fill="white" stroke="black" stroke-opacity="0.2"
                                                            stroke-width="0.510638" />
                                                        <path
                                                            d="M1.80005 5.00093H3.77018C3.94928 5.00093 4.48659 4.94123 4.72539 5.77704C4.90449 6.31435 5.14329 7.15016 5.5015 8.40388H5.6209C5.97911 7.09046 6.27761 6.19495 6.39701 5.77704C6.63582 4.94123 7.23282 5.00093 7.47163 5.00093H9.32235V10.7322H7.41193V7.32926H7.29252L6.27761 10.7322H4.84479L3.82988 7.32926H3.65077V10.7322H1.80005M10.0985 5.00093H12.0089V8.40388H12.188L13.4417 5.59794C13.6805 5.06063 14.2178 5.00093 14.2178 5.00093H16.0088V10.7322H14.0984V7.32926H13.979L12.7253 10.1352C12.4865 10.6725 11.8895 10.7322 11.8895 10.7322H10.0985M18.576 9.00089V10.7322H16.785V7.74717H22.6356C22.3968 8.46358 21.561 9.00089 20.6058 9.00089"
                                                            fill="#0F754E" />
                                                        <path
                                                            d="M22.755 7.38803C22.9938 6.31342 22.2774 5 20.7252 5H16.6655C16.7849 6.25372 17.8595 7.38803 18.9939 7.38803"
                                                            fill="url(#paint0_linear_3101_94302)" />
                                                    </g>
                                                </g>
                                                <defs>
                                                    <linearGradient id="paint0_linear_3101_94302" x1="22.0386"
                                                        y1="4.22389" x2="17.2625" y2="4.22389"
                                                        gradientUnits="userSpaceOnUse">
                                                        <stop stop-color="#1F5CD7" />
                                                        <stop offset="1" stop-color="#02AEFF" />
                                                    </linearGradient>
                                                    <clipPath id="clip0_3101_94302">
                                                        <rect width="24" height="16" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            <svg width="26" height="18" viewBox="0 0 26 18" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M23 1H3C1.89543 1 1 1.89543 1 3V15C1 16.1046 1.89543 17 3 17H23C24.1046 17 25 16.1046 25 15V3C25 1.89543 24.1046 1 23 1Z"
                                                    fill="white" stroke="black" stroke-opacity="0.2"
                                                    stroke-width="0.5" />
                                                <path
                                                    d="M11.0991 9.07031L9.69659 9.87894L8.39526 12.1324L13.7037 9.07031H11.0991Z"
                                                    fill="#874691" />
                                                <path
                                                    d="M15.1062 6.75781L13.7037 7.56644L12.4023 9.8199L17.7089 6.75781H15.1062Z"
                                                    fill="#DA1844" />
                                                <path
                                                    d="M13.7037 5.95267L12.4023 3.69922V8.3191V9.8234V14.4433L13.7037 12.1898V5.95267Z"
                                                    fill="#F9B229" />
                                                <path
                                                    d="M12.4023 3.69922L13.7037 5.95267L15.1062 6.7613H17.7089L12.4023 3.69922Z"
                                                    fill="#F07F1A" />
                                                <path
                                                    d="M12.4023 8.32031V14.4445L13.7037 12.191V10.5718L12.4023 8.32031Z"
                                                    fill="#72B22C" />
                                                <path
                                                    d="M15.1062 11.3828L13.7037 12.1915L12.4023 14.4449L17.7089 11.3828H15.1062Z"
                                                    fill="#00743E" />
                                                <path
                                                    d="M8.39526 6.00781V12.132L9.69659 9.87854V8.26127L8.39526 6.00781Z"
                                                    fill="#5F5A94" />
                                                <path
                                                    d="M12.4024 8.31875V8.32073L8.39526 6.00781L9.69659 8.26127L15.1063 11.3808H17.7089L12.4024 8.31875Z"
                                                    fill="#0D90CD" />
                                            </svg>

                                        </template>
                                        <template v-else-if="['gitld','tradersclub'].includes(brand)">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="16"
                                                viewBox="0 0 25 16" fill="none">
                                                <g clip-path="url(#clip0_954_20151)">
                                                    <mask id="mask0_954_20151" style="mask-type:luminance"
                                                        maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="16">
                                                        <path d="M24.5 0H0.5V16H24.5V0Z" fill="white" />
                                                    </mask>
                                                    <g mask="url(#mask0_954_20151)">
                                                        <path
                                                            d="M22.4574 0H2.54255C1.41448 0 0.5 0.924315 0.5 2.06452V13.9355C0.5 15.0757 1.41448 16 2.54255 16H22.4574C23.5855 16 24.5 15.0757 24.5 13.9355V2.06452C24.5 0.924315 23.5855 0 22.4574 0Z"
                                                            fill="white" stroke="black" stroke-opacity="0.2"
                                                            stroke-width="0.510638" />
                                                        <path
                                                            d="M3.09188 5.84726C2.55761 5.55107 1.94785 5.31286 1.26611 5.14755L1.29471 5.01881H4.08992C4.4688 5.03223 4.77623 5.14746 4.87627 5.55438L5.48375 8.48174L5.66984 9.36342L7.37127 5.01881H9.20836L6.47756 11.3833H4.64037L3.09188 5.84726ZM10.5597 11.3901H8.82236L9.90902 5.01881H11.6462L10.5597 11.3901ZM16.8577 5.17457L16.6214 6.55038L16.4643 6.48272C16.1499 6.3539 15.7349 6.22516 15.1701 6.23877C14.4842 6.23877 14.1766 6.5165 14.1695 6.78766C14.1695 7.08594 14.5416 7.28251 15.1492 7.57403C16.1502 8.02816 16.6145 8.5839 16.6076 9.30919C16.5935 10.6309 15.4067 11.4851 13.5838 11.4851C12.8043 11.4782 12.0536 11.322 11.6462 11.146L11.8893 9.71575L12.118 9.81755C12.6828 10.055 13.0545 10.1565 13.7481 10.1565C14.2483 10.1565 14.7846 9.95971 14.7915 9.53288C14.7915 9.25496 14.563 9.05145 13.8908 8.73966C13.2332 8.43454 12.3539 7.92627 12.3682 7.01117C12.3756 5.77086 13.5838 4.90332 15.2994 4.90332C15.9715 4.90332 16.515 5.04566 16.8577 5.17457ZM19.1668 9.13298H20.6108C20.5394 8.81444 20.2104 7.28936 20.2104 7.28936L20.089 6.74037C20.0032 6.97757 19.8532 7.36395 19.8604 7.35035C19.8604 7.35035 19.3099 8.76696 19.1668 9.13298ZM21.3113 5.01881L22.7129 11.39H21.1043C21.1043 11.39 20.9469 10.658 20.897 10.4343H18.6664C18.6019 10.6036 18.3018 11.39 18.3018 11.39H16.4788L19.0594 5.54744C19.2382 5.13394 19.5531 5.01881 19.9675 5.01881H21.3113Z"
                                                            fill="#171E6C" />
                                                    </g>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_954_20151">
                                                        <rect width="24" height="16" fill="white"
                                                            transform="translate(0.5)" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="18"
                                                viewBox="0 0 25 18" fill="none">
                                                <path
                                                    d="M22.5 1H2.5C1.39543 1 0.5 1.89543 0.5 3V15C0.5 16.1046 1.39543 17 2.5 17H22.5C23.6046 17 24.5 16.1046 24.5 15V3C24.5 1.89543 23.6046 1 22.5 1Z"
                                                    fill="white" stroke="black" stroke-opacity="0.2"
                                                    stroke-width="0.5" />
                                                <path
                                                    d="M9.5 14C12.2614 14 14.5 11.7614 14.5 9C14.5 6.23858 12.2614 4 9.5 4C6.73858 4 4.5 6.23858 4.5 9C4.5 11.7614 6.73858 14 9.5 14Z"
                                                    fill="#EB001B" />
                                                <path
                                                    d="M15.5 14C18.2614 14 20.5 11.7614 20.5 9C20.5 6.23858 18.2614 4 15.5 4C12.7386 4 10.5 6.23858 10.5 9C10.5 11.7614 12.7386 14 15.5 14Z"
                                                    fill="#F79E1B" />
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                    d="M12.5 4.99951C13.7144 5.91172 14.5 7.36406 14.5 8.99988C14.5 10.6357 13.7144 12.088 12.5 13.0002C11.2856 12.088 10.5 10.6357 10.5 8.99988C10.5 7.36406 11.2856 5.91172 12.5 4.99951Z"
                                                    fill="#FF5F00" />
                                            </svg>
                                            <svg width="24" height="16" viewBox="0 0 24 16" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_3101_94302)">
                                                    <mask id="mask0_3101_94302" style="mask-type:luminance"
                                                        maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="16">
                                                        <path d="M24 0H0V16H24V0Z" fill="white" />
                                                    </mask>
                                                    <g mask="url(#mask0_3101_94302)">
                                                        <path
                                                            d="M21.9574 0H2.04255C0.914482 0 0 0.924315 0 2.06452V13.9355C0 15.0757 0.914482 16 2.04255 16H21.9574C23.0855 16 24 15.0757 24 13.9355V2.06452C24 0.924315 23.0855 0 21.9574 0Z"
                                                            fill="white" stroke="black" stroke-opacity="0.2"
                                                            stroke-width="0.510638" />
                                                        <path
                                                            d="M1.80005 5.00093H3.77018C3.94928 5.00093 4.48659 4.94123 4.72539 5.77704C4.90449 6.31435 5.14329 7.15016 5.5015 8.40388H5.6209C5.97911 7.09046 6.27761 6.19495 6.39701 5.77704C6.63582 4.94123 7.23282 5.00093 7.47163 5.00093H9.32235V10.7322H7.41193V7.32926H7.29252L6.27761 10.7322H4.84479L3.82988 7.32926H3.65077V10.7322H1.80005M10.0985 5.00093H12.0089V8.40388H12.188L13.4417 5.59794C13.6805 5.06063 14.2178 5.00093 14.2178 5.00093H16.0088V10.7322H14.0984V7.32926H13.979L12.7253 10.1352C12.4865 10.6725 11.8895 10.7322 11.8895 10.7322H10.0985M18.576 9.00089V10.7322H16.785V7.74717H22.6356C22.3968 8.46358 21.561 9.00089 20.6058 9.00089"
                                                            fill="#0F754E" />
                                                        <path
                                                            d="M22.755 7.38803C22.9938 6.31342 22.2774 5 20.7252 5H16.6655C16.7849 6.25372 17.8595 7.38803 18.9939 7.38803"
                                                            fill="url(#paint0_linear_3101_94302)" />
                                                    </g>
                                                </g>
                                                <defs>
                                                    <linearGradient id="paint0_linear_3101_94302" x1="22.0386"
                                                        y1="4.22389" x2="17.2625" y2="4.22389"
                                                        gradientUnits="userSpaceOnUse">
                                                        <stop stop-color="#1F5CD7" />
                                                        <stop offset="1" stop-color="#02AEFF" />
                                                    </linearGradient>
                                                    <clipPath id="clip0_3101_94302">
                                                        <rect width="24" height="16" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            <svg width="26" height="18" viewBox="0 0 26 18" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M23 1H3C1.89543 1 1 1.89543 1 3V15C1 16.1046 1.89543 17 3 17H23C24.1046 17 25 16.1046 25 15V3C25 1.89543 24.1046 1 23 1Z"
                                                    fill="white" stroke="black" stroke-opacity="0.2"
                                                    stroke-width="0.5" />
                                                <path
                                                    d="M11.0991 9.07031L9.69659 9.87894L8.39526 12.1324L13.7037 9.07031H11.0991Z"
                                                    fill="#874691" />
                                                <path
                                                    d="M15.1062 6.75781L13.7037 7.56644L12.4023 9.8199L17.7089 6.75781H15.1062Z"
                                                    fill="#DA1844" />
                                                <path
                                                    d="M13.7037 5.95267L12.4023 3.69922V8.3191V9.8234V14.4433L13.7037 12.1898V5.95267Z"
                                                    fill="#F9B229" />
                                                <path
                                                    d="M12.4023 3.69922L13.7037 5.95267L15.1062 6.7613H17.7089L12.4023 3.69922Z"
                                                    fill="#F07F1A" />
                                                <path
                                                    d="M12.4023 8.32031V14.4445L13.7037 12.191V10.5718L12.4023 8.32031Z"
                                                    fill="#72B22C" />
                                                <path
                                                    d="M15.1062 11.3828L13.7037 12.1915L12.4023 14.4449L17.7089 11.3828H15.1062Z"
                                                    fill="#00743E" />
                                                <path
                                                    d="M8.39526 6.00781V12.132L9.69659 9.87854V8.26127L8.39526 6.00781Z"
                                                    fill="#5F5A94" />
                                                <path
                                                    d="M12.4024 8.31875V8.32073L8.39526 6.00781L9.69659 8.26127L15.1063 11.3808H17.7089L12.4024 8.31875Z"
                                                    fill="#0D90CD" />
                                            </svg>
                                        </template>
                                        <template v-else>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="16"
                                                viewBox="0 0 25 16" fill="none">
                                                <g clip-path="url(#clip0_954_20151)">
                                                    <mask id="mask0_954_20151" style="mask-type:luminance"
                                                        maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="16">
                                                        <path d="M24.5 0H0.5V16H24.5V0Z" fill="white" />
                                                    </mask>
                                                    <g mask="url(#mask0_954_20151)">
                                                        <path
                                                            d="M22.4574 0H2.54255C1.41448 0 0.5 0.924315 0.5 2.06452V13.9355C0.5 15.0757 1.41448 16 2.54255 16H22.4574C23.5855 16 24.5 15.0757 24.5 13.9355V2.06452C24.5 0.924315 23.5855 0 22.4574 0Z"
                                                            fill="white" stroke="black" stroke-opacity="0.2"
                                                            stroke-width="0.510638" />
                                                        <path
                                                            d="M3.09188 5.84726C2.55761 5.55107 1.94785 5.31286 1.26611 5.14755L1.29471 5.01881H4.08992C4.4688 5.03223 4.77623 5.14746 4.87627 5.55438L5.48375 8.48174L5.66984 9.36342L7.37127 5.01881H9.20836L6.47756 11.3833H4.64037L3.09188 5.84726ZM10.5597 11.3901H8.82236L9.90902 5.01881H11.6462L10.5597 11.3901ZM16.8577 5.17457L16.6214 6.55038L16.4643 6.48272C16.1499 6.3539 15.7349 6.22516 15.1701 6.23877C14.4842 6.23877 14.1766 6.5165 14.1695 6.78766C14.1695 7.08594 14.5416 7.28251 15.1492 7.57403C16.1502 8.02816 16.6145 8.5839 16.6076 9.30919C16.5935 10.6309 15.4067 11.4851 13.5838 11.4851C12.8043 11.4782 12.0536 11.322 11.6462 11.146L11.8893 9.71575L12.118 9.81755C12.6828 10.055 13.0545 10.1565 13.7481 10.1565C14.2483 10.1565 14.7846 9.95971 14.7915 9.53288C14.7915 9.25496 14.563 9.05145 13.8908 8.73966C13.2332 8.43454 12.3539 7.92627 12.3682 7.01117C12.3756 5.77086 13.5838 4.90332 15.2994 4.90332C15.9715 4.90332 16.515 5.04566 16.8577 5.17457ZM19.1668 9.13298H20.6108C20.5394 8.81444 20.2104 7.28936 20.2104 7.28936L20.089 6.74037C20.0032 6.97757 19.8532 7.36395 19.8604 7.35035C19.8604 7.35035 19.3099 8.76696 19.1668 9.13298ZM21.3113 5.01881L22.7129 11.39H21.1043C21.1043 11.39 20.9469 10.658 20.897 10.4343H18.6664C18.6019 10.6036 18.3018 11.39 18.3018 11.39H16.4788L19.0594 5.54744C19.2382 5.13394 19.5531 5.01881 19.9675 5.01881H21.3113Z"
                                                            fill="#171E6C" />
                                                    </g>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_954_20151">
                                                        <rect width="24" height="16" fill="white"
                                                            transform="translate(0.5)" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="18"
                                                viewBox="0 0 25 18" fill="none">
                                                <path
                                                    d="M22.5 1H2.5C1.39543 1 0.5 1.89543 0.5 3V15C0.5 16.1046 1.39543 17 2.5 17H22.5C23.6046 17 24.5 16.1046 24.5 15V3C24.5 1.89543 23.6046 1 22.5 1Z"
                                                    fill="white" stroke="black" stroke-opacity="0.2"
                                                    stroke-width="0.5" />
                                                <path
                                                    d="M9.5 14C12.2614 14 14.5 11.7614 14.5 9C14.5 6.23858 12.2614 4 9.5 4C6.73858 4 4.5 6.23858 4.5 9C4.5 11.7614 6.73858 14 9.5 14Z"
                                                    fill="#EB001B" />
                                                <path
                                                    d="M15.5 14C18.2614 14 20.5 11.7614 20.5 9C20.5 6.23858 18.2614 4 15.5 4C12.7386 4 10.5 6.23858 10.5 9C10.5 11.7614 12.7386 14 15.5 14Z"
                                                    fill="#F79E1B" />
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                    d="M12.5 4.99951C13.7144 5.91172 14.5 7.36406 14.5 8.99988C14.5 10.6357 13.7144 12.088 12.5 13.0002C11.2856 12.088 10.5 10.6357 10.5 8.99988C10.5 7.36406 11.2856 5.91172 12.5 4.99951Z"
                                                    fill="#FF5F00" />
                                            </svg>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="16"
                                                viewBox="0 0 25 16" fill="none">
                                                <g clip-path="url(#clip0_954_20164)">
                                                    <mask id="mask0_954_20164" style="mask-type:luminance"
                                                        maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="16">
                                                        <path d="M24.5 0H0.5V16H24.5V0Z" fill="white" />
                                                    </mask>
                                                    <g mask="url(#mask0_954_20164)">
                                                        <path
                                                            d="M22.5 0H2.5C1.39543 0 0.5 0.89543 0.5 2V14C0.5 15.1046 1.39543 16 2.5 16H22.5C23.6046 16 24.5 15.1046 24.5 14V2C24.5 0.89543 23.6046 0 22.5 0Z"
                                                            fill="#016FD0" />
                                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                                            d="M14.2642 13.3938V7.69238L24.4118 7.70149V9.27638L23.2389 10.5298L24.4118 11.7947V13.403H22.5392L21.544 12.3048L20.5559 13.4071L14.2642 13.3938Z"
                                                            fill="#FFFFFE" />
                                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                                            d="M14.9419 12.7687V8.31982H18.7142V9.34471H16.1633V10.0404H18.6533V11.0482H16.1633V11.7315H18.7142V12.7687H14.9419Z"
                                                            fill="#016FD0" />
                                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                                            d="M18.6954 12.7689L20.7827 10.5419L18.6953 8.32007H20.3109L21.5864 9.7301L22.8655 8.32007H24.4117V8.35507L22.3688 10.5419L24.4117 12.7057V12.7689H22.85L21.5519 11.3447L20.2671 12.7689H18.6954Z"
                                                            fill="#016FD0" />
                                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                                            d="M14.7374 2.63184H17.1834L18.0426 4.58269V2.63184H21.0624L21.5832 4.09341L22.1057 2.63184H24.4116V8.33323H12.2251L14.7374 2.63184Z"
                                                            fill="#FFFFFE" />
                                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                                            d="M15.2007 3.25146L13.2266 7.69664H14.5805L14.953 6.80647H16.9709L17.3431 7.69664H18.7306L16.7649 3.25146H15.2007ZM15.3703 5.8089L15.9623 4.39383L16.5538 5.8089H15.3703Z"
                                                            fill="#016FD0" />
                                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                                            d="M18.7119 7.69582V3.25073L20.615 3.25727L21.5943 5.99L22.5799 3.25073H24.4115V7.69582L23.2329 7.70625V4.6529L22.1204 7.69582H21.0446L19.9089 4.64247V7.69582H18.7119Z"
                                                            fill="#016FD0" />
                                                    </g>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_954_20164">
                                                        <rect width="24" height="16" fill="white"
                                                            transform="translate(0.5)" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="16"
                                                viewBox="0 0 25 16" fill="none">
                                                <g clip-path="url(#clip0_954_20176)">
                                                    <mask id="mask0_954_20176" style="mask-type:luminance"
                                                        maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="16">
                                                        <path d="M24.5 0H0.5V16H24.5V0Z" fill="white" />
                                                    </mask>
                                                    <g mask="url(#mask0_954_20176)">
                                                        <path
                                                            d="M22.4972 15.7499H22.4994C23.4545 15.7581 24.2381 14.9773 24.25 14.0042V2.0063C24.2462 1.53569 24.0589 1.08617 23.7297 0.756802C23.4014 0.428269 22.9589 0.246149 22.4972 0.250071L2.50064 0.250062C2.04109 0.246149 1.59858 0.428269 1.27028 0.756802C0.941145 1.08617 0.753838 1.53569 0.750008 2.00426L0.75 13.9937C0.753838 14.4643 0.941145 14.9138 1.27028 15.2432C1.59858 15.5717 2.04109 15.7538 2.50277 15.7499H22.4972Z"
                                                            fill="white" />
                                                        <path
                                                            d="M22.4962 16.2499C22.4958 16.2499 22.4955 16.2499 22.4951 16.2499M22.4972 15.7499H22.4994C23.4545 15.7581 24.2381 14.9773 24.25 14.0042V2.0063C24.2462 1.53569 24.0589 1.08617 23.7297 0.756802C23.4014 0.428269 22.9589 0.246149 22.4972 0.250071L2.50064 0.250062C2.04109 0.246149 1.59858 0.428269 1.27028 0.756802C0.941145 1.08617 0.753838 1.53569 0.750008 2.00426L0.75 13.9937C0.753838 14.4643 0.941145 14.9138 1.27028 15.2432C1.59858 15.5717 2.04109 15.7538 2.50277 15.7499H22.4972Z"
                                                            stroke="black" stroke-opacity="0.2" stroke-width="0.5" />
                                                        <path
                                                            d="M13.1123 15.9999H22.4972C23.0239 16.0043 23.5309 15.7993 23.9065 15.4299C24.2821 15.0605 24.4955 14.557 24.4999 14.0303V11.6716C20.9561 13.7059 17.1127 15.1668 13.1123 15.9999Z"
                                                            fill="#F27712" />
                                                        <path
                                                            d="M23.6725 9.29643H22.82L21.8601 8.03023H21.769V9.29643H21.0738V6.15161H22.1C22.9028 6.15161 23.3663 6.48264 23.3663 7.0785C23.3663 7.56678 23.0766 7.88126 22.5552 7.98057L23.6725 9.29643ZM22.6463 7.10333C22.6463 6.79712 22.4145 6.63988 21.9842 6.63988H21.769V7.59161H21.9676C22.4145 7.59161 22.6463 7.42609 22.6463 7.10333ZM18.6407 6.15161H20.6104V6.68126H19.3359V7.38471H20.5607V7.92264H19.3359V8.77505H20.6104V9.30471H18.6407V6.15161ZM16.4063 9.37919L14.9001 6.14333H15.6614L16.6132 8.26195L17.5732 6.14333H18.318L16.7952 9.37919H16.4228H16.4063ZM10.1083 9.37092C9.04902 9.37092 8.22143 8.65092 8.22143 7.71574C8.22143 6.8054 9.06557 6.06885 10.1249 6.06885C10.4228 6.06885 10.6711 6.12678 10.9773 6.25919V6.98747C10.7454 6.75965 10.4334 6.63187 10.1083 6.63161C9.44626 6.63161 8.94143 7.11161 8.94143 7.71574C8.94143 8.35299 9.43798 8.80816 10.1414 8.80816C10.4559 8.80816 10.6959 8.70885 10.9773 8.46057V9.18885C10.6628 9.32126 10.398 9.37092 10.1083 9.37092ZM8.00626 8.33643C8.00626 8.94885 7.50143 9.37092 6.77315 9.37092C6.2435 9.37092 5.86281 9.18885 5.54005 8.77505L5.99522 8.38609C6.15246 8.66747 6.41729 8.80816 6.74833 8.80816C7.06281 8.80816 7.28626 8.61781 7.28626 8.36954C7.28626 8.22885 7.22005 8.12126 7.07936 8.0385C6.9251 7.96365 6.76446 7.90271 6.59936 7.85643C5.94557 7.64954 5.72212 7.42609 5.72212 6.98747C5.72212 6.47436 6.20212 6.0854 6.83109 6.0854C7.22833 6.0854 7.58419 6.20954 7.88212 6.44126L7.51798 6.85505C7.37366 6.69683 7.16938 6.60671 6.95522 6.60678C6.65729 6.60678 6.44212 6.75574 6.44212 6.95436C6.44212 7.11988 6.56626 7.21092 6.98005 7.35161C7.77453 7.59988 8.00626 7.83161 8.00626 8.34471V8.33643ZM4.58833 6.15161H5.2835V9.30471H4.58833V6.15161ZM2.35384 9.30471H1.32764V6.15161H2.35384C3.47936 6.15161 4.25729 6.79712 4.25729 7.72402C4.25729 8.19574 4.02557 8.64264 3.62005 8.94057C3.27246 9.18885 2.8835 9.30471 2.34557 9.30471H2.35384ZM3.16488 6.93781C2.93315 6.75574 2.66833 6.68954 2.21315 6.68954H2.02281V8.77505H2.21315C2.66005 8.77505 2.94143 8.6923 3.16488 8.52678C3.40488 8.32816 3.54557 8.03023 3.54557 7.72402C3.54557 7.41781 3.40488 7.12816 3.16488 6.93781Z"
                                                            fill="black" />
                                                        <path
                                                            d="M12.9139 6.06885C12.0036 6.06885 11.2588 6.79712 11.2588 7.69919C11.2588 8.65919 11.9705 9.37919 12.9139 9.37919C13.8408 9.37919 14.5691 8.65092 14.5691 7.72402C14.5691 6.79712 13.8491 6.06885 12.9139 6.06885Z"
                                                            fill="#F27712" />
                                                    </g>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_954_20176">
                                                        <rect width="24" height="16" fill="white"
                                                            transform="translate(0.5)" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </template>
                                    </div>
                                </template>
                            </BaseInput>
                            <BaseInput 
                                v-model="name" 
                                :title="tokens.newDesign.cardHolderName" 
                                :placeholder="tokens.newDesign.cardHolderName"
                            />
                            <BaseInput 
                                v-model="comment" 
                                :title="tokens.newDesign.comment" 
                                :placeholder="tokens.newDesign.comment"
                            />
                        </div>
                    </div>
                    <div class="confirm">
                        <SendWithdrawal
                            :disabled="!amount || cardNumber.length < (brand === 'trilonex' ? 1 : 19) || !name"
                            :info="getInfo"
                            @send="showSuccessful()"
                        />
                    </div>
                </template>
                <template v-else>
                    <SuccessfulTab
                        :details="getDetails"
                        @closeSuccessfullTab="closeSuccessfullTab"
                        @showAccounts="showAccounts"
                    />
                </template>
            </template>
        </BasePanel>
    </div>
</template>

<script>
import BasePanel from "@/new-design/shared/ui/panels/BasePanel.vue"
import BaseInput from "@/new-design/shared/ui/Inputs/BaseInput.vue"
import SendWithdrawal from "@/new-design/features/Withdrawal/ui/SendWithdrawal.vue"
import {mapGetters} from "vuex"
import SuccessfulTab from "@/new-design/pages/withdrawal/tabs/SuccessfulTab.vue"
import {currencySign} from "@/common/helpers"
import {MODAL, MODAL_FULLSCREEN} from "@/store/mutations.type"
import {BRAND} from "@/common/config"

export default {
    name: "CreditDebitTab",
    components: {SuccessfulTab, SendWithdrawal, BaseInput, BasePanel},
    mounted() {
        this.init()
    },
    data() {
        return {
            amount: null,
            cardNumber: "",
            name: "",
            comment: "",
            successful: false,
            brand: BRAND,
        }
    },
    methods: {
        init() {
            this.amount = null
            this.cardNumber = ""
            this.name = ''
            this.comment = ""
            this.successful = false
        },
        showSuccessful() {
            this.successful = true
        },
        showAccounts() {
            this.init()

            this.$store.commit(MODAL, {
                fullscreen: true
            })

            this.$store.commit(MODAL, {
                hamburgerMenu: false
            })

            this.$store.commit(MODAL_FULLSCREEN, {
                page: 'accounts'
            })
        },
        closeSuccessfullTab() {
            this.init()
            this.successful = false
        },
        currencySign
    },
    computed: {
        ...mapGetters(['activeAccount','tokens']),
        getInfo() {
            let payload = {
                method: 'card',
                amount: this.amount,
                cardNumber: this.cardNumber,
                name: this.name,
                activeAccount: this.activeAccount,
            }

            if(this.comment.trim()){
                payload.comment = this.comment
            }
            
            return payload;
        },
        getDetails() {
            return [
                {
                    title: 'Amount withdrawn',
                    value: currencySign(this.activeAccount.currency) + ' ' + this.amount,
                },
                {
                    title: 'Withdrawal to',
                    value: this.formattedCardNumber
                },
                {
                    title: 'Currency',
                    value: this.activeAccount.currency
                },
                {
                    title: 'Time',
                    value: this.formattedWithdrawalTime
                },
                {
                    title: 'Transaction status',
                    value: 'Processing'
                },
            ]
        },
        formattedWithdrawalTime() {
            const options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            }
            return new Date().toLocaleString('en-GB', options).replace(',', '')
        },
        formattedCardNumber() {
            if(!this.cardNumber) {
                return
            }

            const lastFourDigits = this.cardNumber.trim().slice(-4)
            return `**** **** **** ${lastFourDigits}`
        }
    }
}
</script>


<style scoped>
.title {
    color: var(--System-OnSurface);
    margin-bottom: 16px;
}

.amount-to,
.card-details {
    margin-bottom: 16px;
}

.cards-list {
    display: flex;
    align-items: center;
    gap: 4px;
}

.inputs-list {
    display: flex;
    gap: 20px;
    flex-direction: column;
}

.confirm {
    margin-top: 24px;
    width: 100%;
    text-align: right;
}
</style>
